import { Card, Table, Typography } from 'antd';
import { PageShell, RefreshButton } from '../components/page-shell.js';
import { useAdminQuery } from '../use-admin-query.js';

type AuditEvent = {
  id: string;
  clerkUserIdHash: string;
  action: string;
  resourceType: string;
  resourceId?: string;
  requestId: string;
  ipHash?: string;
  before?: unknown;
  after?: unknown;
  createdAt: string;
};

export function AuditPage() {
  const query = useAdminQuery<AuditEvent[]>('/admin/v1/audit-events');
  return (
    <PageShell
      title="Administrative audit"
      description="Hashed administrator and network identities with redacted mutation metadata. Secret fields are never stored in audit payloads."
      action={
        <RefreshButton
          loading={query.loading}
          onClick={() => void query.refresh()}
        />
      }
      error={query.error}
    >
      <Card>
        <Table
          rowKey="id"
          loading={query.loading}
          dataSource={query.data ?? []}
          expandable={{
            expandedRowRender: (row) => (
              <Typography.Paragraph>
                <code className="compact-json">
                  {JSON.stringify({ before: row.before, after: row.after })}
                </code>
              </Typography.Paragraph>
            ),
          }}
          columns={[
            {
              title: 'Created',
              dataIndex: 'createdAt',
              render: (value: string) => new Date(value).toLocaleString(),
            },
            { title: 'Action', dataIndex: 'action' },
            { title: 'Resource', dataIndex: 'resourceType' },
            { title: 'Resource ID', dataIndex: 'resourceId', render: dash },
            {
              title: 'Admin hash',
              dataIndex: 'clerkUserIdHash',
              render: shortHash,
            },
            { title: 'Request', dataIndex: 'requestId' },
          ]}
        />
      </Card>
    </PageShell>
  );
}

function dash(value: unknown): string {
  return typeof value === 'string' && value ? value : '—';
}

function shortHash(value: string): string {
  return `${value.slice(0, 10)}…`;
}
